<template lang="pug">
  .intervals-table-row(v-if="showTableRow")
    .row(:class="classesRow")
      .label-block
        p.label {{fieldStart.label}}

      .value-block.start(:class="classesStart" @click="openModal(fieldStart)")
        .changed-value(v-if="newValueStart && challengeMode")
          row-creator(:item="fieldStart", :value="newValueStart")
          challenge-icon
        row-creator(:item="fieldStart", :value="oldValueStart",
          :class="{old: newValueStart && challengeMode}")

      .value-block.end(:class="classesEnd" @click="openModal(fieldEnd)")
        .changed-value(v-if="newValueEnd && challengeMode")
          row-creator(:item="itemEnd", :value="newValueEnd")
          challenge-icon
        row-creator(:item="itemEnd", :value="oldValueEnd",
          :class="{old: newValueEnd && challengeMode}")
</template>
<script>
import { mapState, mapMutations, mapGetters, } from 'vuex'
import {
  TOGGLE_CHALLENGE_MODAL,
  SET_CHALLENGE,
  TOGGLE_CHALLENGE_EXPIRATION_MODAL,
} from '@/store/modules/record/modules/challenge/mutations-types'
import { getFieldByPath, } from '@/utils/challenge'
import Challenge from '@/mixins/challenge'
import RowCreator from './RowCreator'
import ChallengeIcon from '../../challenge-components/ChallengeIcon'

export default {
  components: {
    RowCreator,
    ChallengeIcon,
  },
  mixins: [ Challenge, ],
  props: {
    itemStart: {
      type: [ Object, Array, ],
      required: true,
    },
    itemEnd: {
      type: [ Object, Array, ],
      required: true,
    },
  },
  data () {
    return {
      fieldStart: {},
      fieldEnd: {},
    }
  },
  computed: {
    showTableRow () {
      return this.showEmptyFields ||
          !this.isEmpty(this.fieldStart.value) ||
          !this.isEmpty(this.fieldEnd.value)
    },
    classesRow () {
      return {
        'disabled': this.challengeMode && this.fieldStart.disabled && this.fieldEnd.disabled,
        'indented': this.fieldStart.indented || this.fieldEnd.indented,
        'changed-row': !!this.newValueStart || !!this.newValueEnd,
      }
    },
    classesStart () {
      return {
        'disabled': this.challengeMode && this.fieldStart.disabled,
        'changed-block': !!this.newValueStart,
      }
    },
    classesEnd () {
      return {
        'disabled': this.challengeMode && this.fieldEnd.disabled,
        'changed-block': !!this.newValueEnd,
      }
    },
    oldValueStart () {
      return this.parseValue(this.fieldStart, this.fieldStart.value)
    },
    newValueStart () {
      return this.getSavedFieldByPath(this.jsonPathStart)
    },
    oldValueEnd () {
      return this.parseValue(this.fieldEnd, this.fieldEnd.value)
    },
    newValueEnd () {
      return this.getSavedFieldByPath(this.jsonPathEnd)
    },
    jsonPathStart () {
      return this.itemStart.jsonPath
    },
    jsonPathEnd () {
      return this.itemEnd.jsonPath
    },

    ...mapState('record', [ 'showEmptyFields', ]),
    ...mapState('record/challenge', [ 'fields', ]),
    ...mapGetters('record/challenge', [ 'getSavedFieldByPath', ]),
  },
  watch: {
    itemStart () {
      this.composeStartField()
    },
    itemEnd () {
      this.composeEndField()
    },
  },
  created () {
    this.composeStartField()
    this.composeEndField()
  },
  methods: {
    composeStartField () {
      const fieldStart = getFieldByPath(this.jsonPathStart)
      this.fieldStart = fieldStart ? {
        ...this.itemStart,
        ...fieldStart,
      } : { ...this.itemStart, }
    },
    composeEndField () {
      const fieldEnd = getFieldByPath(this.jsonPathEnd)
      this.fieldEnd = fieldEnd ? {
        ...this.itemEnd,
        ...fieldEnd,
      } : { ...this.itemEnd, }
    },
    parseValue (field, val) {
      return field.getValue ? field.getValue(val) : val
    },
    isEmpty (value) {
      return !value || value === '' || (Array.isArray(value) && value.length === 0)
    },
    openModal (item) {
      if (this.challengeMode && !item.disabled) {
        this.setChallenge({
          ...item,
          title: item.label,
          oldValue: item.value,
        })
        item.isExpiration ? this.toggleChallengeExpirationModal() : this.toggleChallengeModal()
      }
    },

    ...mapMutations('record/challenge', {
      toggleChallengeModal: TOGGLE_CHALLENGE_MODAL,
      toggleChallengeExpirationModal: TOGGLE_CHALLENGE_EXPIRATION_MODAL,
      setChallenge: SET_CHALLENGE,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .intervals-table-row
    display flex
    flex-direction column
    width 100%
    margin-bottom 2px
    font-size 95%

    .row
      min-height 45px
      width 100%
      display flex
      justify-content space-between



      &.indented
        margin-top 15px

      &.disabled
        cursor not-allowed

        .label-block, .value-block
          background-color $disabled-bg

          .label, .value
            color $disabled-color!important

      &.changed-row
          .label-block
            border 2px solid $primary-color
            border-right none

          .value-block
            border 2px solid $primary-color
            border-left none

            &:nth-child(2)
              border-right none

      .label-block, .value-block
        line-height 1.5
        display flex
        padding 15px 20px
        background-color $default-color-light-2

      .label-block
        align-items flex-start
        justify-content flex-end
        width 20%
        min-width 320px
        margin-right 5px
        text-align right

        .label
          color $default-color
          font-weight 700

      .value-block
        align-items center
        margin-left 5px
        text-align left
        justify-content flex-start
        flex 1

        .column
          justify-content center
          align-items flex-start
          flex-direction column

        .value.old, .old .value
          color $default-color-middle

        .value
          color $default-color-bold-1
          font-weight 500

          &.link
            color $default-color-bold-1
            font-weight 500
            cursor pointer
            line-height 1.5rem
            border-bottom 1px solid $info-color
            transition all .2s ease

            &:hover
              color $primary-color
              border-bottom 1px solid $primary-color

          &.n-a
            color $default-color-middle

          &.status
            font-size 85%
            display flex
            align-items center

            .status-icon
              font-size 125%
              margin-right 8px

        &.changed-block
          flex-direction column
          align-items flex-start

        .changed-value
          margin-bottom 20px
          width 100%
          display flex
          justify-content space-between
          align-items flex-start

          &.column
            justify-content center
            align-items flex-start
            flex-direction column

        &:hover
          cursor pointer
          background-color $primary-hover

        &.disabled
          cursor not-allowed
          background-color $disabled-bg


  @media (max-width: $tablet)
    .intervals-table-row
      margin-bottom 0
      border-bottom none
      font-size 90%

      .row
        border-bottom 1px solid $default-color-light-1
        padding 5px 20px
        flex-direction column

        .label-block, .value-block
          justify-content flex-start
          padding 5px 0
          background-color transparent
          width 100%
          min-width auto

        .label-block
          margin-right 0
          text-align left

          .label
            color $default-color-middle
            font-weight 600

        .value-block
          margin-left 0
</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/TableRowInterval.vue